import { lazy } from 'react';

// ----------------------------------------------------------------------

const SubscriptionsPage = lazy(() => import('../pages/Subscriptions.page'));
const AddPackagePage = lazy(() => import('../pages/AddPackagePage'));
const EditPackagePage = lazy(() => import('../pages/EditPackagePage'));

// ----------------------------------------------------------------------

const SubscriptionsRoutes = [
    {
        path: '/subscriptions',
        element: <SubscriptionsPage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/subscriptions/add-package',
        element: <AddPackagePage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/subscriptions/edit-package/:id',
        element: <EditPackagePage />,
        layout: 'default',
        isAuthReq: true,
    },

];

export { SubscriptionsRoutes };
